import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import i18n from '../../utils/translate';
import { animateScroll } from 'react-scroll';

import { PAYMENT_RESPONSE } from '../../utils/constants';

import './styles.scss';

const propTypes = {
  vacation: PropTypes.bool,
  documents: PropTypes.any,
  cubaTrip: PropTypes.bool,
  visaRequired: PropTypes.bool,
  status: PropTypes.any,
  message: PropTypes.any
};

const defaultProps = {
  vacation: false,
  message: (
    <React.Fragment>
      <div>{i18n('Ihr Online-Abschluss war erfolgreich.')}</div>
      <div>{i18n('Sie erhalten in Kürze ein Bestätigungsmail.')}</div>
    </React.Fragment>
  )
};

class PaymentSuccess extends Component {
  componentDidMount() {
    sessionStorage.clear();
    const { onSuccess } = this.props;
    animateScroll.scrollToTop({ duration: 0 });

    if (onSuccess) {
      onSuccess();
    }
  }

  componentWillUnmount() {
    if (this.props.resetData) {
      this.props.resetData();
    }
  }

  render() {
    const { vacation, documents, cubaTrip, visaRequired, status, message } = this.props;
    let cols;
    let renderPolicy;
    if (status === PAYMENT_RESPONSE.SUCCESS) {
      renderPolicy = true;
    } else {
      if (status === PAYMENT_RESPONSE.REVEIW || status === PAYMENT_RESPONSE.INITIATED) {
        renderPolicy = false;
      }
    }

    if (!vacation) cols = '12';
    else {
      if ((visaRequired && !cubaTrip) || (!visaRequired && cubaTrip)) {
        cols = '4';
      } else if (visaRequired && cubaTrip) {
        cols = '3';
      } else {
        cols = '6';
      }
    }

    if (renderPolicy) {
      return (
        <div>
          <div className="success-box">
            <div className="success-msg-wrapper">{message}</div>
            <div className="row pdf-wrapper">
              {vacation && documents.folderUrl && (
                <div className={`col-xs-12 col-sm-${cols}`}>
                  <span className="pdf-icon" />
                  <a
                    href={`${GRAWE.api_root}${documents && documents.policyUrl && documents.policyUrl.substring(1)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n('Versicherungspolizze')}
                  </a>
                </div>
              )}
              {vacation && documents.folderUrl && (
                <div className={`col-xs-12 col-sm-${cols}`}>
                  <span className="pdf-icon" />
                  <a
                    href={`${GRAWE.api_root}${documents && documents.folderUrl && documents.folderUrl.substring(1)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n('Produktfolder')}
                  </a>
                </div>
              )}
              {vacation && visaRequired && documents.folderUrl && (
                <div className={`col-xs-12 col-sm-${cols}`}>
                  <span className="pdf-icon" />
                  <a
                    href={`${GRAWE.api_root}${documents && documents.visaUrl && documents.visaUrl.substring(1)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n('Versicherungsbestätigung für Visumsantrag')}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="success-box">
            <div className="success-msg-wrapper">
              <div>{i18n('Ihr Online-Abschluss war erfolgreich.')}</div>
              <div>
                {i18n(
                  'Der Download der Polizze funktioniert derzeit aus technischen Gründen nicht. Ihre Versicherungspolizze und allenfalls beantragte Versicherungsbestätigung(en) erhalten Sie an einem der folgenden Arbeitstage. FürFragen stehen wir Ihnen gerne unter 0316/8037-6222 bzw. reise.center.vs@grawe.atzur Verfügung.'
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

PaymentSuccess.propTypes = propTypes;
PaymentSuccess.defaultProps = defaultProps;

export default PaymentSuccess;
